import type { Map as MapboxMap } from "mapbox-gl";
import type { Bbox } from "@carnet/ui/utils/geo";
import { bottomSlotFramingInset, FIT_PADDING } from "@carnet/ui/utils/mapFraming";

export const MAP_FIT_MAX_ZOOM = 15;
export const MAP_POINT_ZOOM = 15;

export function fitMapToBbox(map: MapboxMap, bbox: Bbox, animate = true) {
  map.fitBounds(
    [
      [bbox.nwLng, bbox.seLat],
      [bbox.seLng, bbox.nwLat],
    ],
    {
      padding: { top: FIT_PADDING, right: FIT_PADDING, bottom: bottomSlotFramingInset(map.getContainer(), FIT_PADDING), left: FIT_PADDING },
      maxZoom: MAP_FIT_MAX_ZOOM,
      animate,
      duration: animate ? 600 : 0,
    }
  );
}
